module.exports = __webpack_public_path__ + "img/cross.7f0eeabf.svg";